"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ImageLinks = _interopRequireDefault(require("../ImageLinks/ImageLinks"));

var _CTAButton = _interopRequireDefault(require("../CTAButton/CTAButton"));

var _ContentBox = _interopRequireDefault(require("../ContentBox/ContentBox"));

var _ComponentTargetID = _interopRequireDefault(require("../ComponentTargetID/ComponentTargetID"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var LinkedContentMapper = function LinkedContentMapperFunction(_ref) {
  var linkedContentData = _ref.linkedContentData,
      dataClient = _ref.dataClient;

  if (!linkedContentData) {
    return null;
  }

  var linkedContentMap = {
    image_links: _ImageLinks["default"],
    cta_button: _CTAButton["default"],
    content_box: _ContentBox["default"],
    component_target_id: _ComponentTargetID["default"]
  };
  var content = linkedContentData.content;
  return Object.keys(content).map(function (sliceType, idx) {
    var Component = linkedContentMap[sliceType];
    var sliceData = content[sliceType];
    var key = "".concat(sliceType, "-").concat(idx);
    return Component && sliceData.length > 0 && /*#__PURE__*/_react["default"].createElement(Component, {
      key: key,
      sliceData: sliceData,
      dataClient: dataClient
    });
  });
};

LinkedContentMapper.propTypes = {
  linkedContentData: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    content: _propTypes["default"].shape({})
  }),
  dataClient: _propTypes["default"].shape({}).isRequired
};
LinkedContentMapper.defaultProps = {
  linkedContentData: null
};
var _default = LinkedContentMapper;
exports["default"] = _default;